import { GET_DRIVERS } from '../actions/apiCalls';
export const drivers = (state = [], action) => {
	switch (action.type) {
		case GET_DRIVERS:
			return [...action.payload];
		default:
			return state;
	}
}
